import React, { useContext, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal';
import Accordion from 'react-bootstrap/Accordion';
import './TCModal.css'
import styles from './TCModal.module.css'
import { dataContext } from '../../../App';
import activityLogSubmission from '../../../helper/activitylog';
import analyticEvent from '../../../helper/gaEvent';
import { pushCleverTapEvent } from '../../../helper/clevertapFunction';

const TCModal = ({ showTCModal, setShowTCModal,setShowRefundModal }) => {
  const { token, setToken, playerData, setPlayerData } = useContext(dataContext);

  function hideModalOperation() {
    setShowTCModal(false)
  }

  useEffect(() => {
    let msisdn = null;
    if (playerData?.id) {
      msisdn = playerData?.msisdn;
    }
    activityLogSubmission("termsConditions", msisdn);
    analyticEvent('termsConditions', 'termsConditions-view')
    pushCleverTapEvent('CheckIn-TC');
  }, [])

  return (
    <>
      <div className={styles.tcModal}>
        <div className={styles.tcModalHeader}>
          <div className="headerTitle" style={{marginBottom: '8px'}}>
            <img src={require('./tc.png')} className={styles.tcModalIcon} alt="terms" />
            <span className={styles.tcModalTitle}>নিয়ম ও শর্তাবলী</span>
          </div>
          <p className={styles.tcModalDescription}>
            Wordly তে আপনাকে স্বাগতম! WORDLY একটি সামাজিক গেমিং প্লাটফর্ম । WORDLY তে বাংলা ও ইংরেজি শব্দ মেলানোর মজার গেম খেলে নিজের শব্দ দক্ষতা যাচাই করুন আর আকর্ষণীয় সব পুরষ্কার জিতে নিন ।
          </p>
          <p className={styles.tcModalDescription}>
            খেলা শুরু করার আগে, অনুগ্রহ করে আপনি নিচের নিয়ম ও শর্তাবলী মনোযোগ সহকারে পড়ুন এবং বুঝুন । এই গেম খেলায় অংশগ্রহণ করে, আপনি নিম্নলিখিত শর্তাবলী মেনে চলতে সম্মত হোন ।
          </p>
        </div>

        <div className={styles.tcModalContent}>
          <Accordion className={styles.accordion}>
            <Accordion.Item eventKey="0" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>খেলার যোগ্যতা</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
                Wordly গেমটি সকল বয়সের এবং জাতীয়তার বাক্তিদের জন্য উন্মুক্ত । কিন্তু, যে কোনো ধরনের প্রতারণা, বাহ্যিক সাহায্যের ব্যবহার, বা Wordly প্ল্যাটফর্মের সাথে হেরফের করার প্রচেষ্টা অবিলম্বে অযোগ্যতার কারণ হবে। অযোগ্য অংশগ্রহণকারীরা কোনো পুরস্কার বা পুরস্কারের জন্য যোগ্য হবে না। আয়োজক সত্তার কর্মচারী এবং পরিবারের সদস্যরা অংশগ্রহণের যোগ্য নন।
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="1" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>লিংক</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
                <a href="https://bl.wordly.quizard.live/" target="_blank" rel="noopener noreferrer">https://bl.wordly.quizard.live/</a>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="2" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>কীভাবে যোগদান করবেন</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
              বাংলালিংক নাম্বার থেকে পেমেন্ট এর মাধ্যমে সাপ্তাহিক ৩০ টাকা চার্জে ব্যবহারকারীরা Memory Match, Wordly এবং Spelling Bee তে সাবস্ক্রিপশন করতে পারবেন। বাংলালিংক নাম্বার থেকে পেমেন্ট এর মাধ্যমে ব্যবহারকারীরা তাদের অ্যাকাউন্টটির সাবস্ক্রিপশন সম্পন্ন করতে পারবেন ।
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="3" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>Memory Match খেলার নিয়ম</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
                <b>কার্ড সাজানো:</b><br />
                সমস্ত কার্ড (সাধারণত জোড়া সংখ্যক) খেলার মাঠে গ্রিড আকারে মুখ নিচে সাজানো হয়।<br />
                প্রতিটি কার্ডের সাথে একটি নির্দিষ্ট চিত্র বা চিহ্ন মেলে, যার জোড়া খেলায় বিদ্যমান।<br /><br />
                <b>খেলোয়াড়ের পালা:</b><br />
                প্রতিবার খেলোয়াড় দুটি কার্ড উল্টবেন।<br />
                যদি উল্টানো দুই কার্ডের চিত্র বা চিহ্ন একই হয়, তাহলে সেগুলি মিল হয় এবং স্থায়ীভাবে উন্মুক্ত থাকবে।<br />
                যদি মিল না হয়, নির্দিষ্ট কিছু সময় (উদাঃ ২-৩ সেকেন্ড) পর কার্ডগুলি আবার মুখ নিচে ফিরিয়ে দেওয়া হবে।<br /><br />
                <b>মনে রাখা কৌশল:</b><br />
                খেলার সময় পূর্বে উল্টানো কার্ডগুলির অবস্থান মনে রাখা অত্যন্ত জরুরি, যাতে পরবর্তীতে দ্রুত মিল খুঁজে পাওয়া যায়।<br /><br />
                <b>সময় গণনা:</b><br />
                খেলার শুরু থেকে শেষ পর্যন্ত সময় মাপা হবে।<br />
                যিনি সব কার্ডের জোড়া মিলিয়ে খেলা সম্পূর্ণ করবেন, তার মোট সময় ধরে নেওয়া হবে।<br />
                বিজয়ী হবে সেই খেলোয়াড় যিনি সর্বনিম্ন সময়ে খেলা শেষ করেন।
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="4" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>WORDLY খেলার নিয়ম</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
                <ul>
                  <li>বাংলা ও ইংরেজি সেগমেন্টে WORDLY তে শব্দ মিল খেলার সুযোগ থাকবে এবং দৈনিক সর্বোচ্চ ২ বার খেলা যাবে ।</li>
                  <li>এলোমেলো কিছু অক্ষর থাকবে, এদের সাজিয়ে একটি অর্থপূর্ণ শব্দ পাওয়া যাবে । কোনো অক্ষর তার সঠিক স্থানে থাকলে সবুজ রেখা দ্বারা সেটি অংশগ্রহণকারীর দৃষ্টিগোচর হবে ।</li>
                  <li>অংশগ্রহণকারীরা প্রতিটি সঠিক শব্দের জন্য ১ পয়েন্ট অর্জন করবে। প্রতি রাউন্ড এর সময় সীমা ১৮০ সেকেন্ড ।</li>
                  <li>প্রতি রাউন্ড এ অংশগ্রহণকারী গণ নির্দিষ্ট সময়ে যে কয়টি সঠিক শব্দ মিল করবে, সেটিই হবে তার ঐ রাউন্ড এর টোটাল স্কোর ।</li>
                  <li>দুটি রাউন্ড এর মধ্যে যে রাউন্ড এর স্কোর বেশি হবে, সেটিই ফাইনাল স্কোর হিসেবে গণনা করা হবে ।</li>
                  <li>Wordly তে উইনার হতে হলে মিনিমাম ৩০ স্কোর করতে হবে</li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="5" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>Spelling Bee খেলার নিয়ম</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
                <ul>
                  <li>স্পেলিং বি সেগমেন্টে ইংরেজিতে ৭ টি লেটার  দেয়া থাকবে। এখান থেকে শব্দ মিল করার সুযোগ থাকবে এবং দৈনিক সর্বোচ্চ ২ বার খেলা যাবে।</li>
                  <li>অংশগ্রহণকারীরা প্রতিটি সঠিক শব্দের জন্য ১ পয়েন্ট অর্জন করবে। প্রতি রাউন্ড এর সময় সীমা ১৮০ সেকেন্ড।</li>
                  <li>দুটি রাউন্ড এর মধ্যে যে রাউন্ড এর স্কোর বেশি হবে, সেটিই ফাইনাল স্কোর হিসেবে গণনা করা হবে ।</li>
                  <li>Spelling Bee তে উইনার হতে হলে মিনিমাম ৩০ স্কোর করতে হবে</li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="6" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>বিজয়ীদের পুরস্কার</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
                Wordly  কর্তৃপক্ষ বিজয়ীদের দৈনিক, টুর্নামেন্ট ভিত্তিক পুরস্কার প্রদান করে থাকে ।<br /><br />
                <b>Memory Match পুরস্কার:</b><br />
                মেমোরি ম্যাচ গেমে প্রতিদিনের শীর্ষ ৩০ জন বিজয়ী পাবেন ১০ টাকা করে মোবাইল রিচার্জ  পুরস্কার।<br />
                ***এক সপ্তাহের ডেইলি প্রাইজ একসাথে সপ্তাহের সোমবার  দেয়া হয়ে থাকে।<br />
                <br />
                <br />
                <b>Wordly  পুরস্কার:</b>
                <ul>
                  <li>দৈনিক পুরস্কার: প্রতিদিনের অংশগ্রহণকারীদের মধ্যে সেরা ২০  জন সঠিক উত্তর প্রদানকারী কে ১০ টাকা মোবাইল রিচার্জ  করা হবে |</li>
                </ul>
                ***এক সপ্তাহের ডেইলি প্রাইজ একসাথে সপ্তাহের সোমবার  দেয়া হয়ে থাকে।<br />
                <br />
                <br />
                <b>Spelling Bee  পুরস্কার:</b>
                <ul>
                  <li>দৈনিক পুরস্কার: প্রতিদিনের অংশগ্রহণকারীদের মধ্যে সেরা  ২০ জন সঠিক উত্তর প্রদানকারী কে ১০ টাকা মোবাইল রিচার্জ  করা হবে |</li>
                </ul>
                ***এক সপ্তাহের ডেইলি প্রাইজ একসাথে সপ্তাহের সোমবার  দেয়া হয়ে থাকে।<br />
                <br />
                <br />
                ** আয়োজক সত্তা তার বিবেচনার ভিত্তিতে পুরস্কার পরিবর্তন বা প্রতিস্থাপন করার অধিকার সংরক্ষণ করে।
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="7" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>বিজয়ী হবার নিয়মাবলী</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
                <ul>
                  <li>নির্দিষ্ট সময় সীমার মধ্যে সর্বাধিক সঠিক শব্দ প্রদানকারী দের মেধাক্রম অনুসারে পুরস্কৃত করা হবে ।</li>
                  <li>বিজয়ী হওয়ার জন্য অংশগ্রহণকারীকে পেইড সাবস্ক্রাইবার হতে হবে ।</li>
                  <li>ক্যাম্পেইন চলাকালীন সময় WORDLY থেকে আনসাবস্ক্রাইব করতে পারবে না । অন্যথায় সর্বোচ্চ স্কোর থাকলেও অযোগ্য হিসেবে ধরা হবে এবং কোনো পুরস্কারের জন্য যোগ্য বিবেচিত হবে না।</li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="8" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>রেফার কোড ব্যাবহারের নিয়ম</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
                WORDLY এর সাইডবার থেকে রেফার অপশনে গেলে আপনার রেফার কোডটি পেয়ে যাবেন।<br />
                <ul>
                  <li>আপনার রেফার কোড শেয়ার করুন। আপনার কোড ব্যবহার করে কেউ সাবস্ক্রিপশন করলে, সেটি সফল রেফার হিসেবে গণ্য হবে।</li>
                  <li>২টি সফল রেফার সম্পন্ন হলে, আপনি পাবেন ২০ টাকা মোবাইল রিচার্জ।</li>
                  <li>অন্য কারো রেফার কোড ব্যবহার করে সাবস্ক্রিপশন করলে, আপনি পরবর্তী রিনিউয়াল সম্পন্ন করলে ২০ টাকা মোবাইল রিচার্জ পাবেন।</li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="9" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>আনসাবস্ক্রাইব করার নিয়ম</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
                Wordly  এর শর্তাবলি তে আন্সাবস্ক্রাইব অপশন থেকে আনসাবস্ক্রিপশন করতে হবে।
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="10" className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionButton}>সাধারণ জিজ্ঞাসা</Accordion.Header>
              <Accordion.Body className={styles.accordionBody}>
                <div style={{marginBottom: '12px'}}>
                  <b>১ | আপনি Wordly কোথায় খেলতে পারেন?</b><br />
                  উঃ <a href="https://bl.wordly.quizard.live/" target="_blank" rel="noopener noreferrer">https://bl.wordly.quizard.live/</a>
                </div>
                <div style={{marginBottom: '12px'}}>
                  <b>২| হেল্পলাইন নম্বরটি কি?</b><br />
                  উঃ <a href="tel:+8801988117755">8801988117755</a>
                </div>
                <div style={{marginBottom: '12px'}}>
                  <b>৩| হেল্পলাইন ফোন করার সময়সূচী ?</b><br />
                  উঃ রবিবার থেকে বৃহস্পতিবার সকাল ১০টা থেকে  বিকাল ৬ টা পর্যন্ত |
                </div>
                <div style={{marginBottom: '12px'}}>
                  <b>৪| সাপোর্ট ইমেইল আইডি কি?</b><br />
                  উঃ <a href="mailto:wordly.live@yahoo.com">wordly.live@yahoo.com</a>
                </div>
                <div>
                  <b>৫| Wordly এর ফেসবুক লিংকটি কি?</b><br />
                  উঃ <a href="https://www.facebook.com/wordly.quizard.live" target="_blank" rel="noopener noreferrer">https://www.facebook.com/wordly.quizard.live</a>
                </div>
              </Accordion.Body>
            </Accordion.Item>

            {((playerData?.isSubscribe) || (playerData?.isSubscribeMemoryMatch) || (playerData?.isSubscribeSpellingBee)) && <Accordion.Item eventKey="14">
              <Accordion.Header>কিভাবে আন্সাবস্ক্রাইব করবেন</Accordion.Header>
              <Accordion.Body>
              আন্সাবস্ক্রাইব করতে ক্লিক করুন <span style={{textDecoration: 'underline', cursor: 'pointer'}} onClick={()=>{setShowRefundModal(true);setShowTCModal(false);}}>এখানে</span>
              </Accordion.Body>
            </Accordion.Item>}
          </Accordion>
        </div>
      </div>
    </>
  )
}

export default TCModal